import { DEXT_FIELD_TYPES } from './dext-field-types';
import { INPUT_FIELD_TYPES, isInputFieldType, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, EVENTS_FIELD_TYPES } from './input-field-types';
import { READONLY_FIELD_TYPES } from './readonly-field-types';
export const FIELD_TYPES = {
  ...INPUT_FIELD_TYPES,
  ...READONLY_FIELD_TYPES,
  SUBMIT_BUTTON: 'SUBMIT_BUTTON'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare

// FieldType is the union of all FIELD_TYPES values (not keys).
// This is needed because Challenges field keys differ from their values.

export { INPUT_FIELD_TYPES, isInputFieldType, CONTACTS_FIELD_TYPES, COMMON_FIELD_TYPES, PAYMENTS_FIELD_TYPES, READONLY_FIELD_TYPES, DEXT_FIELD_TYPES, EVENTS_FIELD_TYPES };
//# sourceMappingURL=field-types.js.map